import LegalLayout from './LegalLayout.jsx';

export default function DatenschutzPage() {
  return (
    <LegalLayout title="Datenschutzerklärung" meta="Stand: Oktober 2026 · tresor.datenputzer.de">
      <section className="legal-section">
        <p>
          <strong>Für wen diese Fassung gilt:</strong> für einzeln gebuchte Tresor-Tarife. Ist der Tresor in
          Ihrem Tarif Tiefenreinigung enthalten, gilt die{' '}
          <a href="https://datenputzer.de/datenschutz#tresor">Datenschutzerklärung von datenputzer.de</a>.
        </p>
      </section>
      <section className="legal-section">
        <h2>1. Überblick</h2>
        <p>
          Diese Datenschutzerklärung gilt für den verschlüsselten Cloudspeicher{' '}
          <strong>Datenputzer Tresor</strong> unter <strong>tresor.datenputzer.de</strong>. Sie ergänzt die
          allgemeine Datenschutzerklärung von datenputzer.de um die spezifischen Verarbeitungen dieses Produkts.
        </p>
        <p>
          <strong>Kernprinzip:</strong> Dateiinhalte werden in Ihrem Browser verschlüsselt (Zero-Knowledge), bevor
          sie gespeichert werden. Der Anbieter kann diese Inhalte ohne Ihr Passwort bzw. Ihre Recovery-Phrase
          nicht lesen.
        </p>
      </section>

      <section className="legal-section">
        <h2>2. Verantwortlicher</h2>
        <p>
          Verantwortlich für die Datenverarbeitung im Zusammenhang mit dem Tresor ist:
        </p>
        <p>
          Kevin Pabst IT-Dienstleistungen („Datenputzer“)<br />
          E-Mail: <a href="mailto:support@datenputzer.de" className="ed-link">support@datenputzer.de</a>
        </p>
        <p>
          Impressum:{' '}
          <a href="https://datenputzer.de/impressum.html" className="ed-link">datenputzer.de/impressum</a>
        </p>
      </section>

      <section className="legal-section">
        <h2>3. Welche Daten verarbeitet werden</h2>
        <h3>3.1 Konto- und Vertragsdaten</h3>
        <p>
          Für die Nutzung des Tresors ist ein Datenputzer-Konto erforderlich. Dabei verarbeiten wir insbesondere
          E-Mail-Adresse, Vertrags- und Abrechnungsdaten (über unseren Zahlungsdienstleister) sowie den
          Aktivierungsstatus Ihres Tresor-Tarifs.
        </p>
        <h3>3.2 Tresor-Metadaten (Server)</h3>
        <p>
          Auf unseren Servern werden gespeichert: ein kryptografischer Salt, ein passwortgeschützter
          Schlüssel-Wrapper (<code>passwordWrapped</code>), optional Recovery-Daten sowie ein verschlüsseltes
          Änderungsjournal. Diese Metadaten sind für den Betrieb des Dienstes erforderlich.
        </p>
        <p>
          <strong>Dateinamen und Ordnerstruktur speichern wir nicht im Klartext.</strong> Beide liegen
          ausschließlich innerhalb des Änderungsjournals, und zwar bereits in Ihrem Browser mit AES-GCM
          verschlüsselt (Feld <code>encrypted_payload</code>). Wir erhalten davon nur einen Chiffretext.
          Im Klartext existieren Dateinamen und Ordnerstruktur nur lokal auf Ihrem Gerät. Ihr Browser
          legt dafür ein Verzeichnis in seiner lokalen Datenbank (IndexedDB) an, sobald Sie Ihren Tresor
          mit Ihrem Passwort entsperrt haben. Dieses lokale Verzeichnis bleibt auf Ihrem Gerät
          gespeichert, auch wenn Sie den Tresor wieder sperren oder den Browser schließen. Sie entfernen es,
          indem Sie in Ihrem Browser die Websitedaten für diese Seite löschen. Uns liegt ohne Ihr
          Passwort kein Schlüssel vor, mit dem wir die Namen entschlüsseln könnten. Auf eine behördliche
          Anordnung hin können wir daher nur den Chiffretext herausgeben.
        </p>
        <p>
          Ohne Verschlüsselung und damit für uns technisch sichtbar sind folgende Betriebsdaten:
          die Größe jeder hochgeladenen Datei in Bytes, die Anzahl ihrer Datenblöcke, Zeitstempel der
          Änderungen, die Anzahl der Änderungsereignisse (also näherungsweise, wie viele Dateien und Ordner
          Sie anlegen, verschieben oder löschen), Ihr belegter Speicherplatz sowie Ihre Sitzungs- und
          Gerätedaten. Aus diesen Angaben lässt sich weder ein Dateiname noch ein Dateiinhalt ableiten.
        </p>
        <h3>3.3 Verschlüsselte Dateiinhalte</h3>
        <p>
          Die eigentlichen Dateiinhalte liegen als verschlüsselte Datenblöcke im Object Storage (siehe Abschnitt 4).
          Ohne Ihren Tresor-Schlüssel sind sie für uns nicht lesbar.
        </p>
        <h3>3.4 Technische Zugriffsdaten</h3>
        <p>
          Beim Aufruf der Website und API werden technische Daten verarbeitet (z. B. IP-Adresse, Zeitstempel,
          angeforderte URL, User-Agent, Fehlercodes). Diese dienen dem Betrieb, der Sicherheit und der Fehleranalyse
          (Art. 6 Abs. 1 lit. f DSGVO). Die IP-Adresse nutzen wir nur kurzzeitig im Arbeitsspeicher, um zu viele
          Anfragen abzuwehren, und speichern sie nicht in Protokollen. Die Zugriffsprotokolle des Webservers enthalten
          keine IP-Adresse und werden nach 30 Tagen gelöscht. Die Anwendungsprotokolle enthalten ebenfalls keine
          IP-Adresse und werden fortlaufend überschrieben.
        </p>
        <h3>3.5 Lokale Verarbeitung im Browser</h3>
        <p>
          Verschlüsselung, Entschlüsselung und temporäre Schlüsselhaltung erfolgen lokal in Ihrem Browser.
          Schlüsselmaterial verbleibt während einer entsperrten Sitzung im Arbeitsspeicher Ihres Geräts und wird
          beim Sperren verworfen. Details: <a href="/docs" className="ed-link">/docs</a>.
        </p>
      </section>

      <section className="legal-section">
        <h2>4. Hosting, Speicherung und Auftragsverarbeiter</h2>
        <p>
          Die Tresor-Anwendung und API werden auf Servern in Deutschland betrieben. Verschlüsselte Dateiinhalte
          werden in <strong>Hetzner Object Storage</strong> (Rechenzentrum Deutschland / EU)
          gespeichert.
        </p>
        <p>
          <strong>Auftragsverarbeiter für Object Storage:</strong> Hetzner Online GmbH, Industriestr. 25,
          91710 Gunzenhausen, Deutschland. Hetzner speichert ausschließlich von uns übermittelte,
          clientseitig verschlüsselte Datenblöcke sowie technisch erforderliche Speicher-Metadaten des
          Object-Storage-Systems. Ein Zugriff auf Klartext-Inhalte ist ohne Ihren Tresor-Schlüssel nicht möglich.
        </p>
        <p>
          <strong>Tresor-Metadatenbank:</strong> Salts, Schlüssel-Wrapper, Recovery-Hüllen, Dateigrößen,
          Quoten und das verschlüsselte Änderungsjournal (mit den darin verschlüsselten Dateinamen und
          Ordnerstrukturen) werden in einer eigenen Datenbank
          auf unserer Infrastruktur in Deutschland gespeichert. Diese Datenbank wird zur Wiederherstellung
          im Störungsfall regelmäßig gesichert (Backups ebenfalls in Deutschland / EU).
        </p>
        <p>
          Die Verarbeitung erfolgt zur Vertragserfüllung (Art. 6 Abs. 1 lit. b DSGVO) sowie zur Wahrung
          berechtigter Interessen an einem sicheren Betrieb (Art. 6 Abs. 1 lit. f DSGVO). Mit Hetzner besteht
          eine Auftragsverarbeitung gemäß Art. 28 DSGVO; auf Anfrage stellen wir Unternehmern zusätzlich einen
          AVV für die Nutzung des Tresors bereit (Abschnitt 9).
        </p>
      </section>

      <section className="legal-section">
        <h2>5. Zahlungsabwicklung</h2>
        <p>
          Die Buchung des Tresor-Tarifs erfolgt über <strong>datenputzer.de/cloud-checkout</strong>.
          Zahlungen werden über <strong>Stripe</strong> abgewickelt. Dabei werden Zahlungsdaten direkt an Stripe
          übermittelt; wir erhalten keine vollständigen Kreditkartendaten.
        </p>
      </section>

      <section className="legal-section" id="cookies">
        <h2>6. Cookies, lokale Speicherung und Tracking</h2>

        <h3>6.1 Kein Tracking, keine Werbe-Cookies</h3>
        <p>
          Der Tresor lädt keinen Analyse-Dienst, kein Werbepixel und kein Skript von einem fremden
          Anbieter. Es gibt hier kein Google Analytics, kein Matomo, kein Facebook-Pixel und keinen
          Testdienst, der Ihr Verhalten misst. Bis zum 27. August 2026 war eine Conversion-Messung
          von Google Ads eingebunden, die nur nach ausdrücklicher Zustimmung geladen wurde. Sie ist
          vollständig entfernt, zusammen mit dem Einwilligungsbanner. Eine Entscheidung, die Sie
          damals getroffen haben, ist damit gegenstandslos und wird nicht mehr ausgelesen.
        </p>
        <p>
          Sie müssen uns das nicht glauben. Öffnen Sie die Entwicklertools Ihres Browsers mit F12, wechseln Sie
          auf <strong>Netzwerk</strong> und laden Sie die Seite neu. Alle Anfragen gehen an
          tresor.datenputzer.de und an datenputzer.de, beim Hoch- und Herunterladen zusätzlich an
          den Speicherort nbg1.your-objectstorage.com. Eine vierte Adresse gibt es nicht.
        </p>
        <p>
          Das ist nicht nur ein Versprechen, der Browser setzt es durch. Unser Server schickt zu
          jeder Seite eine Content-Security-Policy mit, die genau diese Adressen erlaubt und sonst
          keine. Ein Werbe- oder Analyseskript könnte hier nicht einmal dann laden, wenn es jemand
          einbauen würde. Die Regel sehen Sie in den Entwicklertools unter <strong>Netzwerk</strong>,
          wenn Sie die Antwort-Header der Seite aufklappen.
        </p>

        <h3>6.2 Cookies, die wir setzen</h3>
        <p>
          Solange Sie nicht angemeldet sind, setzt der Tresor überhaupt kein Cookie. Erst mit der
          Anmeldung kommen drei dazu. Alle drei sind <strong>HttpOnly</strong>, also für JavaScript
          nicht lesbar, und alle drei dienen ausschließlich dem Zugang zu Ihrem Konto:
        </p>
        <ul className="legal-list">
          <li>
            <strong>dp_session</strong>: der kurzlebige Zugangsnachweis für Ihr Datenputzer-Konto.
            Laufzeit 15 Minuten, danach wird er im Hintergrund erneuert.
          </li>
          <li>
            <strong>dp_refresh</strong>: erneuert diesen Zugangsnachweis, damit Sie sich nicht alle 15
            Minuten neu anmelden müssen. Laufzeit 30 Tage.
          </li>
          <li>
            <strong>dp_tresor_device</strong>: erkennt dieses Gerät wieder und begrenzt die Zahl der
            angemeldeten Geräte. Laufzeit 12 Monate. Beim Abmelden wird es gelöscht.
          </li>
        </ul>
        <p>
          Diese drei Cookies sind für den von Ihnen angeforderten Dienst unbedingt erforderlich, ihr
          Einsatz ist deshalb nach § 25 Abs. 2 Nr. 2 TDDDG einwilligungsfrei. Rechtsgrundlage der
          Verarbeitung ist Art. 6 Abs. 1 lit. b DSGVO für die Erfüllung des Vertrags und Art. 6 Abs.
          1 lit. f DSGVO für die Sicherheit der Anmeldung. Ein Einwilligungsbanner ist dafür nicht
          erforderlich, und seit dem Wegfall der Conversion-Messung gibt es hier auch keines mehr.
          Nachsehen können Sie das in den Entwicklertools unter <strong>Application</strong> und dort
          unter <strong>Cookies</strong>. Finden Sie dort ein viertes Cookie von uns, schreiben Sie uns.
        </p>

        <h3>6.3 Was im Speicher Ihres Browsers liegt</h3>
        <p>
          Ihre Einstellungen liegen im Local Storage Ihres Browsers. Sie verlassen Ihr Gerät
          nicht und wir können sie nicht auslesen. Es sind genau diese Einträge:
        </p>
        <ul className="legal-list">
          <li><strong>tresor_theme_pref</strong>: helle oder dunkle Darstellung</li>
          <li><strong>tresor_auto_lock_minutes</strong>: nach wie vielen Minuten ohne Aktivität sich der Tresor sperrt</li>
          <li><strong>tresor_lock_upload_policy</strong>: ob laufende Uploads beim Sperren zu Ende laufen dürfen</li>
          <li><strong>tresor_lock_on_tab_hidden</strong>: ob der Tresor sperrt, wenn Sie den Browser-Tab wechseln</li>
          <li><strong>tresor_file_sort</strong>, <strong>tresor_upload_detail</strong>, <strong>tresor_allow_large</strong>: Sortierung der Dateiliste, aufgeklappte Upload-Ansicht, Bestätigung für sehr große Dateien</li>
        </ul>
        <p>
          Im Session Storage, der sich mit dem Schließen des Tabs leert, liegen
          <strong> tresor_customer_active</strong>, <strong> tresor_status_cache</strong> und
          <strong> tresor_post_logout</strong>. Sie merken sich für die Dauer Ihres Besuchs, ob Ihr
          Tarif aktiv ist und dass Sie sich gerade abgemeldet haben.
        </p>
        <p>
          Zusätzlich legt der Tresor Ihre Dateiliste und bereits entschlüsselte Dateien in der
          IndexedDB Ihres Browsers ab, damit Sie sie ohne erneuten Download wiederfinden. Der
          Hauptschlüssel selbst liegt ausschließlich im Arbeitsspeicher und wird beim Sperren
          verworfen. Diesen lokalen Zwischenspeicher können Sie jederzeit selbst leeren, in den
          Einstellungen des Tresors unter <strong>Lokaler Zwischenspeicher</strong>. Ihre Dateien
          in der Cloud bleiben dabei unangetastet und werden danach wieder geladen.
        </p>
      </section>

      <section className="legal-section">
        <h2>7. Speicherdauer</h2>
        <p>
          Vertrags- und Abrechnungsdaten speichern wir gemäß gesetzlicher Aufbewahrungsfristen. Tresor-Metadaten
          und verschlüsselte Inhalte werden gelöscht, wenn Sie den Dienst kündigen und die Löschfrist abgelaufen ist,
          sofern keine gesetzlichen Pflichten entgegenstehen.
        </p>
        <p>
          Löschen Sie eine Datei endgültig, bewahrt der Objektspeicher ihre verschlüsselten Blöcke noch
          30 Tage als ältere Fassung auf und entfernt sie danach automatisch. Das schützt vor versehentlichem
          Löschen und vor Löschen mit einer gestohlenen Anmeldung. Lesbar sind diese Blöcke für niemanden. Wird Ihr ganzes Konto
          gelöscht, entfernen wir auch alle älteren Fassungen sofort.
        </p>
      </section>

      <section className="legal-section">
        <h2>8. Ihre Rechte</h2>
        <p>Sie haben gegenüber dem Anbieter insbesondere folgende Rechte:</p>
        <ul className="legal-list">
          <li>Auskunft (Art. 15 DSGVO)</li>
          <li>Berichtigung (Art. 16 DSGVO)</li>
          <li>Löschung (Art. 17 DSGVO)</li>
          <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
          <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
          <li>Widerspruch (Art. 21 DSGVO)</li>
          <li>Beschwerde bei einer Aufsichtsbehörde (Art. 77 DSGVO)</li>
        </ul>
        <p>
          Anfragen richten Sie an{' '}
          <a href="mailto:support@datenputzer.de" className="ed-link">support@datenputzer.de</a>.
        </p>
        <p>
          Ein Hinweis zu Auskunft und Datenübertragbarkeit: Ihre Dateiinhalte, Dateinamen und Ordnerstruktur
          sind für uns nicht entschlüsselbar. Wir können sie deshalb nicht in eine Auskunft aufnehmen und
          nicht für Sie exportieren. Diesen Teil Ihrer Daten holen Sie selbst aus Ihrem entsperrten Tresor,
          über den Download Ihrer Dateien und den Export Ihres lokalen Verzeichnisses. Wir erteilen Auskunft
          über alle Daten, die uns tatsächlich im Klartext vorliegen, also Konto- und Vertragsdaten,
          Dateigrößen, Zeitstempel, Speicherbelegung sowie Sitzungs- und Zugriffsdaten.
        </p>
      </section>

      <section className="legal-section">
        <h2>9. Auftragsverarbeitung (B2B)</h2>
        <p>
          Nutzen Sie den Tresor als Unternehmer und speichern Sie personenbezogene Daten Dritter, kann ein
          Auftragsverarbeitungsvertrag (AVV) gemäß Art. 28 DSGVO erforderlich sein. Kontaktieren Sie uns dafür unter{' '}
          <a href="mailto:support@datenputzer.de" className="ed-link">support@datenputzer.de</a>.
        </p>
      </section>

      <section className="legal-section">
        <h2>10. Sicherheit</h2>
        <p>
          Die Übertragung erfolgt verschlüsselt per TLS. Dateien werden clientseitig mit AES-GCM verschlüsselt.
          Trotz sorgfältiger technischer Maßnahmen kann ein absoluter Schutz im Internet nicht garantiert werden.
          Bewahren Sie Passwort und Recovery-Phrase sicher auf.
        </p>
      </section>

      <section className="legal-section">
        <h2>11. Änderungen</h2>
        <p>
          Wir passen diese Datenschutzerklärung an, wenn sich der Dienst oder die Rechtslage ändert. Die jeweils
          aktuelle Fassung finden Sie stets unter dieser URL.
        </p>
      </section>
    </LegalLayout>
  );
}
